<template>
  <!-- Modal backdrop -->
  <div
    v-if="isVisible"
    class="modal-backdrop fade show"
  ></div>

  <!-- Modal -->
  <div
    class="modal fade"
    :class="{ show: isVisible }"
    :style="{ display: isVisible ? 'block' : 'none' }"
    tabindex="-1"
    :aria-hidden="!isVisible"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-warning">
          <h5 class="modal-title">
            <span class="material-icons me-2" style="vertical-align: middle;">warning</span>
            {{ $t('plan_trail.reference_edit_warning_modal.warning_editing_referenced_route') }}
          </h5>
        </div>
        <div class="modal-body">
          <i18n-t keypath="plan_trail.reference_edit_warning_modal.route_name_is_being_used_in" tag="p" class="mb-3" scope="global">
            <template #route_name><strong>{{ routeName }}</strong></template>
          </i18n-t>

          <div v-if="hikes.length === 0" class="text-muted text-center py-4">
            {{ $t('plan_trail.reference_edit_warning_modal.this_route_is_not_being_used') }}
          </div>

          <ul v-else class="list-group mb-3">
            <li v-for="hike in hikes" :key="hike.id" class="list-group-item">
              <a :href="`/hikes/${hike.slug}/edit`" target="_blank" class="text-decoration-none">
                {{ hike.name }}
                <span class="material-icons ms-2" style="font-size: 16px; vertical-align: middle;">open_in_new</span>
              </a>
            </li>
          </ul>

          <div class="alert alert-danger mb-0">
            <strong>{{ $t('plan_trail.reference_edit_warning_modal.changes_you_make_will_update_this') }}</strong>
            {{ $t('plan_trail.reference_edit_warning_modal.are_you_sure_you_want_to') }}
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('shared.cancel_2') }}</button>
          <button type="button" class="btn btn-primary" @click="confirm">{{ $t('plan_trail.reference_edit_warning_modal.continue_editing') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  setup() {
    const routeName = ref('');
    const hikes = ref([]);
    const isVisible = ref(false);
    const resolveCallback = ref(null);

    function show(route) {
      return new Promise((resolve) => {
        routeName.value = route.name;
        hikes.value = route.referencedHikes || [];
        resolveCallback.value = resolve;
        isVisible.value = true;
      });
    }

    function confirm() {
      isVisible.value = false;
      if (resolveCallback.value) {
        resolveCallback.value(true);
      }
    }

    function cancel() {
      isVisible.value = false;
      if (resolveCallback.value) {
        resolveCallback.value(false);
      }
    }

    return {
      routeName,
      hikes,
      isVisible,
      show,
      confirm,
      cancel
    };
  }
});
</script>

<style scoped>
.bg-warning {
  background-color: #fddf00 !important;

  h5{
    color: var(--dark) !important;
  }
}

.list-group-item a {
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.modal-header .material-icons {
  font-size: 24px;
}
</style>
